import Axios from "axios";
import {
    SET_COMPANY_LIST,
    UNSET_COMPANY_LIST,
    SET_CURRENT_COMPANY,
    UNSET_CURRENT_COMPANY
  } from "@/store/mutation-types";
import { saveUpdateCompany, getCompanyList } from "@/store/api";
// initial state
const state = {
  getCompanyList: [],
  currentCompany: JSON.parse(localStorage.getItem("company")) || "",
};

const getters = {
  getCompanyList(state) {
    return state.getCompanyList;
  },
  getCurrentCompany(state) {
    let company = JSON.parse(localStorage.getItem("company"));
    state.currentCompany = company;
    return state.currentCompany ? state.currentCompany : company;
  },
};
const mutations = {
  [SET_COMPANY_LIST](state, data) {
    state.getCompanyList = data;
  },
  [UNSET_COMPANY_LIST](state) {
    state.getCompanyList = [];
  },
  [SET_CURRENT_COMPANY](state, company) {
    state.currentCompany = company;
  },
  [UNSET_CURRENT_COMPANY](state) {
    state.currentCompany = "";
  }
};

const actions = {

  saveUpdateCompany({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCompany, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCompanyList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCompanyList, data)
        .then(function (response) {
          commit('SET_COMPANY_LIST',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_COMPANY_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
